module.exports = __webpack_public_path__ + "img/English-04.4aff05bf.jpg";